const fillPalette = [
  'rgba(43, 162, 28, 0.8)', // Primary Green
  'rgba(10, 195, 218, 0.8)', // Primary Cyan
  'rgba(50, 205, 50, 0.8)', // Lime Green
  'rgba(0, 191, 255, 0.8)', // Sky Blue
  'rgba(255, 221, 0, 0.8)', // Golden Yellow
  'rgba(111, 66, 193, 0.8)', // Royal Purple
  'rgba(220, 53, 69, 0.8)', // Crimson Red
  'rgba(40, 167, 69, 0.8)', // Vibrant Green
  'rgba(255, 87, 51, 0.8)', // Burnt Orange
  'rgba(30, 144, 255, 0.8)' // Dodger Blue
];

const strokePalette = [
  'rgba(43, 162, 28, 1)', // Primary Green
  'rgba(10, 195, 218, 1)', // Primary Cyan
  'rgba(50, 205, 50, 1)', // Lime Green
  'rgba(0, 191, 255, 1)', // Sky Blue
  'rgba(255, 221, 0, 1)', // Golden Yellow
  'rgba(111, 66, 193, 1)', // Royal Purple
  'rgba(220, 53, 69, 1)', // Crimson Red
  'rgba(40, 167, 69, 1)', // Vibrant Green
  'rgba(255, 87, 51, 1)', // Burnt Orange
  'rgba(30, 144, 255, 1)' // Dodger Blue
];


const formatValue = (val: any) => {
  if (typeof val === "number") {
    const isNegative = val < 0;
    val = Math.abs(val);

    if (val >= 1000000000) {
      return (isNegative ? '-' : '') + (val / 1000000000).toFixed(2) + "B";
    } else if (val >= 1000000) {
      return (isNegative ? '-' : '') + (val / 1000000).toFixed(2) + "M";
    } else if (val >= 1000) {
      return (isNegative ? '-' : '') + (val / 1000).toFixed(2) + "K";
    } else {
      return (isNegative ? '-' : '') + val;
    }
  } else {
    return val;
  }
};


export { strokePalette, fillPalette, formatValue };